import { MRT_ColumnFiltersState, MRT_SortingState } from 'material-react-table';

export const getParams = (searchParams: URLSearchParams) => {
    const currentPage = parseInt(searchParams.get('page') || '1', 10) - 1;
    const currentSize = parseInt(searchParams.get('size') || '5', 10);

    const filtersFromUrl: MRT_ColumnFiltersState = [];
    const sortingFromUrl: MRT_SortingState = [];

    for (const [key, value] of searchParams.entries()) {
        if (key.startsWith('sort.')) {
            const columnId = key.replace('sort.', '');
            sortingFromUrl.push({ id: columnId, desc: value === 'desc' });
        } else if (key !== 'page' && key !== 'size') {
            filtersFromUrl.push({ id: key, value });
        }
    }
    return { currentPage, currentSize, filtersFromUrl, sortingFromUrl };
};
